import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const CaseHeader = styled.span<{ $variant: 'bull' | 'bear' | 'base' }>`
  ${typographyV2.titleBase};
  color: ${({ $variant }) => {
    switch ($variant) {
      case 'bull':
        return 'var(--viz-bullish)';
      case 'bear':
        return 'var(--viz-bearish)';
      default:
        return 'var(--text-soft)';
    }
  }};
`;
